import React, { useState, useCallback } from 'react';
import styles from './WellSlider.module.css';
import { DEFAULT_OVERLAY_OPACITY } from '../utils';

interface WellSliderProps {
  label?: string;
  min?: number;
  max?: number;
  value?: number;
  disabled?: boolean;
  dispalyMinValue?: boolean;
  onChange?: (value: number) => void;
}

const WellSlider = (props: WellSliderProps) => {
  const {
    value: controlledValue,
    min = 0,
    max = 100,
    label = '',
    disabled = false,
    dispalyMinValue = false,
    onChange,
  } = props;
  const [internalValue, setInternalValue] = useState(DEFAULT_OVERLAY_OPACITY);
  const value = controlledValue ?? internalValue;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (disabled) {
        return;
      }
      const newValue = Number(e.target.value);
      setInternalValue(newValue);
      onChange?.(newValue);
    },
    [onChange, disabled],
  );

  const fillPercent = ((value - min) / (max - min)) * 100;

  return (
    <div className={`${styles.container} ${disabled ? styles.disabled : ''}`}>
      <span className={styles.label}>{label}</span>
      {dispalyMinValue ? <span className={styles.value}>{min}</span> : null}
      <input
        type="range"
        min={min}
        max={max}
        step={1}
        value={value}
        disabled={disabled}
        onChange={handleChange}
        className={styles.slider}
        style={{
          background: disabled
            ? 'var(--slider-track-disabled)'
            : `linear-gradient(to right, var(--slider-track-fill) 0%, var(--slider-track-fill) ${fillPercent}%, var(--slider-track-empty) ${fillPercent}%, var(--slider-track-empty) 100%)`,
        }}
      />
      <span className={styles.value}>{value}</span>
    </div>
  );
};

export default WellSlider;
